function CreateMaker() {
    var companyThemePath = "ECTR";
    $("#map").gMap({
        controls: {
            panControl: true,
            zoomControl: true,
            mapTypeControl: true,
            scaleControl: true,
            streetViewControl: true,
            overviewMapControl: true
        },
        scrollwheel: true,
        maptype: 'ROADMAP',
        icon: {
            image: "/Images/" + companyThemePath+"/map_maker.png",
            iconsize: [40, 39],
            iconanchor: [20, 39]
        },
        latitude: 41.049074,
        longitude: 28.9939318,
        zoom: 15
    });

    if ($("body.stores").length > 0) {
        setTimeout(function () {
            if ($(".StoresMap .dismissButton").length > 0) {
                $(".StoresMap .dismissButton").trigger("click");
            }
        }, 1500);
    }
}

function MapFunctions() {
    CreateMaker();

    $(document).on("click", ".StoresContainer .StoresBody .StoreItem", function () {
        var latitude = $(this).attr('data-latitude');
        var longitude = $(this).attr('data-longitude');

        $('#map').gMap('centerAt', { latitude: latitude, longitude: longitude, zoom: 18 });

        $("html, body").stop().animate({ scrollTop: 0 }, 500, 'swing');
    });

    $(".StoresBody .row .StoreItem").each(function (index) {
        $('#map').gMap('addMarker', { latitude: $(this).attr("data-latitude"), longitude: $(this).attr("data-longitude"), html: 'Some HTML content' });
    }); 
}

$(document).ready(function () {
    //MapFunctions();

    $(document).on("change", ".StoresContainer .StoresFilter .CityDrop", function () {
        var cityID = $(this).val();

        if (cityID != null && cityID != "" && cityID != undefined) {
            $(".StoresContainer .StoresBody .StoreItem").hide();
            $(".StoresContainer .StoresBody .StoreItem[data-city=" + cityID + "]").show();
        }
        else {
            $(".StoresContainer .StoresBody .StoreItem").show();
        }
    });
});
